import React from 'react'
import CaseStudy from './CaseStudy'

export default class CaseStudyList extends React.Component {
  constructor(props) {
    super(props)
    this.caseStudiesReordered = [...this.props.caseStudies].reverse()
  }

  render() {
    return (
      <section className="case-study-list">
        {this.caseStudiesReordered.map((caseStudy) =>
            <CaseStudy
              description={caseStudy.description}
              details={caseStudy.details}
              employer={caseStudy.employer}
              key={caseStudy.id}
              link={caseStudy.link}
              title={caseStudy.title}
              time={caseStudy.time}
            />
          )
        }
      </section>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/page-specific/work/CaseStudyList.js